<script lang="ts">
  import { onMount } from 'svelte';
  import { api, ApiError } from '../lib/api';
  import ActivityRow from './ActivityRow.svelte';
  import type { Activity } from '../../../shared/types';

  interface Props {
    id: string;
    onBack?: () => void;
  }
  let { id, onBack }: Props = $props();

  let activity: Activity | null = $state(null);
  let loading = $state(true);
  let notFound = $state(false);
  let error: string | null = $state(null);

  onMount(async () => {
    try {
      activity = await api.getActivity(id);
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) notFound = true;
      else error = 'Kunne ikke laste aktiviteten.';
    } finally {
      loading = false;
    }
  });

  function onDeleted() {
    activity = null;
    if (onBack) onBack();
  }
</script>

<section aria-label="Aktivitet">
  {#if onBack}
    <div class="row" style="margin-bottom: 1rem;">
      <button type="button" onclick={onBack}>← Tilbake</button>
    </div>
  {/if}

  {#if loading}
    <p class="muted">Laster …</p>
  {:else if notFound}
    <div class="card">
      <h2>Fant ikke aktiviteten</h2>
      <p class="muted">
        Lenken peker ikke til noen aktivitet — den kan være slettet, eller
        privat og bare synlig for eieren.
      </p>
    </div>
  {:else if error}
    <p class="error">{error}</p>
  {:else if activity}
    <ActivityRow activity={activity} onDeleted={onDeleted} />
  {/if}
</section>
